import { isEmpty } from "lodash";
import dayjs from "./date";

export const TIME_RANGE_KEYS_ALL = ["24h", "7d", "30d", "90d", "1y", "all"];

export const PAST_TIME_RANGE_OPTION_MAP = {
    "24h": "Past 24 Hours",
    "7d": "Past 7 days",
    "30d": "Past 30 days",
    "90d": "Past 90 days",
    "1y": "Past 1 Year",
    "all": "All Time",
};

export const TIME_RANGE_OPTION_MAP = {
    "24h": "24 Hours",
    "7d": "7 days",
    "30d": "30 days",
    "90d": "90 days",
    "1y": "1 Year",
    "all": "All Time",
};

export const TIME_RANGE_TO_DAYS = {
    "24h": 1,
    "7d": 7,
    "30d": 30,
    "90d": 90,
    "1y": 365,
};

export const NEXT_TIME_RANGE_OPTION_MAP = {
    "next7d": "Next 7 days",
    "next30d": "Next 30 days",
    "next90d": "Next 90 days",
};

export const NEXT_TIME_RANGE_TO_DAYS = {
    "next7d": 7,
    "next30d": 30,
    "next90d": 90,
};

export const NEXT_RANGE_KEYS = new Set(Object.keys(NEXT_TIME_RANGE_TO_DAYS));

export const isNextRange = (value) => NEXT_RANGE_KEYS.has(value);

export const PRESET_RANGE_KEYS = new Set([...Object.keys(TIME_RANGE_TO_DAYS), ...NEXT_RANGE_KEYS, "all"]);

export const isPresetRange = (value) => PRESET_RANGE_KEYS.has(value);

export const matchExactPreset = (days) => {
    const map = { 1: "24h", 7: "7d", 30: "30d", 90: "90d", 365: "1y" };
    return map[days] || null;
};

export const getSelectOptions = ({ omit = [], labelAttr = "children", keyList = [], selectOptionMap = {} } = {}) => {
    const selectOptions = [];

    if (isEmpty(keyList)) {
        keyList.push(...Object.keys(selectOptionMap));
    }

    keyList.forEach((itemKey) => {
        if (Array.isArray(omit) && omit.includes(itemKey)) return;
        if (!selectOptions.find((s) => s.value === itemKey)) {
            selectOptions.push({ [labelAttr]: selectOptionMap[itemKey], value: itemKey });
        }
    });

    return selectOptions;
};

export const getTimeRangeSelectOptions = ({ omit = [], keyList = [], labelAttr = "children", showPastLabel = true } = {}) => {
    const tmpKeyList = !isEmpty(keyList) ? keyList : TIME_RANGE_KEYS_ALL;
    return getSelectOptions({
        omit,
        labelAttr,
        keyList: tmpKeyList,
        selectOptionMap: showPastLabel ? PAST_TIME_RANGE_OPTION_MAP : TIME_RANGE_OPTION_MAP,
    });
};

// ─── Custom date range format: "YYYY-MM-DD–YYYY-MM-DD" (en-dash separator) ───

export const formatCustomRange = (start, end) =>
    `${dayjs(start).format('YYYY-MM-DD')}–${dayjs(end).format('YYYY-MM-DD')}`;

export const parseCustomRange = (value) => {
    const parts = value?.split('–');
    if (parts?.length === 2) {
        const start = dayjs(parts[0]);
        const end = dayjs(parts[1]);
        if (start.isValid() && end.isValid()) return { start: start.toDate(), end: end.toDate() };
    }
    return null;
};

export const isCustomRangeFormat = (value) =>
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}–\d{4}-\d{2}-\d{2}$/.test(value);
